import type { ISkillVersion } from "@/api/skills";

export function sortSkillVersionsByRecency(
    versions: readonly ISkillVersion[]
): ISkillVersion[] {
    return [...versions].sort(
        (a, b) => b.version_number - a.version_number || b.id - a.id
    );
}
